import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import {
    getClassFromSubject,
    getSubjectId,
    getTeacherSubjects,
    readActiveSubjectId,
    resolveActiveSubject,
    writeActiveSubjectId,
} from "../utils/teacherSubjects";

export function useTeacherTeaching() {
    const { currentUser } = useSelector((state) => state.user);
    const teacherId = currentUser?._id || currentUser?.id;
    const subjects = useMemo(() => getTeacherSubjects(currentUser), [currentUser]);

    const [activeSubjectId, setActiveSubjectIdState] = useState(() =>
        readActiveSubjectId(teacherId)
    );

    useEffect(() => {
        const resolved = resolveActiveSubject(currentUser, activeSubjectId);
        const id = getSubjectId(resolved);
        if (id && String(id) !== String(activeSubjectId)) {
            setActiveSubjectIdState(id);
        }
    }, [currentUser, subjects, activeSubjectId, teacherId]);

    const activeSubject = useMemo(
        () => resolveActiveSubject(currentUser, activeSubjectId),
        [currentUser, activeSubjectId]
    );

    const activeClass = useMemo(() => getClassFromSubject(activeSubject), [activeSubject]);

    const setActiveSubjectId = useCallback(
        (subjectId) => {
            setActiveSubjectIdState(subjectId);
            writeActiveSubjectId(teacherId, subjectId);
        },
        [teacherId]
    );

    return {
        subjects,
        activeSubject,
        activeSubjectId: getSubjectId(activeSubject),
        activeClass,
        activeClassId: activeClass?._id || activeClass?.id || null,
        className: activeClass?.sclassName || "—",
        subjectName: activeSubject?.subName || "—",
        hasMultipleSubjects: subjects.length > 1,
        setActiveSubjectId,
    };
}
